export function shouldShowMobileMore(visibleRouteCount: number, isStaff: boolean): boolean {
  return !isStaff && visibleRouteCount >= 5;
}

export const restrictedStaffMobileRoutes = ["/app", "/app/tasks", "/app/settings"] as const;

export function getMobileNavigationPaths(isStaff: boolean, visiblePaths: string[]): string[] {
  return isStaff ? [...restrictedStaffMobileRoutes] : visiblePaths;
}
